exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".information_message_area{background:#fff;padding:0 12px 16px}.information_message{background:#fff1f1;border:1px solid #f2d0df;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:4px;line-height:13px;font-size:13px;color:#ed1e79;padding:0 8px 0 16px;height:40px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;justify-items:center;place-items:center;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;vertical-align:middle}.information_message .message_text{position:relative;margin:0;width:100%;color:#de0000;text-decoration:none}.information_message:after{content:\"\";min-width:16px;min-height:16px;background:url(/static/img/common/arrow_right_pink.svg) no-repeat 50%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ce88ec6","scoped":false,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/InformationMessage.vue
// module id = trl0
// module chunks = 0